var React = require("react");
let LoginUtil =           require("../util/LoginUtil.js");
var SiteHeader =          require("../controls/SiteHeader.jsx");
var Footer =              require("../controls/Footer.jsx");

class CheckLoginSuccess extends React.Component {
    
    constructor(){
        super();
        this.onSearch = this.onSearch.bind(this);
    }

    componentDidMount(){
        // check if login succeeded
        if(LoginUtil.isLogin()){
            // if so, redirect
            let redirect = this.props.history.location.search;
            // remove the '?' at the beginning
            var actualRedirect = redirect.substring(1);
            this.props.history.push(actualRedirect);
        } else {
            console.log("log in failed"); 
        }
    }
    
    // for the very top header area
    onSearch(value){
        this.props.history.push(`/search?q=${value}`);
    }
    
    render() {
        return  <div className="pageNotFound">
                    <SiteHeader type="Explore" onSearch={this.onSearch}/>
                    <h1 className="pageNotFound__title"> Login Attempt Unsuccessful</h1>
                    <p className="pageNotFound__description">Your browser might have third party cookies disabled, most browsers disable them by default.  <br/>We are working on removing this requirement, but until then, please enable third party cookies to continue.
                    <br/><br/> In Safari you must also deselect "Prevent cross-site tracking". </p>
                    <Footer />
                </div>
    }
}

module.exports = CheckLoginSuccess;
